import React from 'react';
import { Spin } from 'antd';
import { ManagePlanProps } from './ManagePlan';

const LazyManagePlan = React.lazy(() => import('./ManagePlan'));
export const AsyncManagePlan: React.FC<ManagePlanProps> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyManagePlan {...props} />
	</React.Suspense>
);
